import styled, { css } from 'styled-components';
import { getStyle as get } from '@ids/ddms-styled/comps/inlineMessage/intuit/light';
import { placements } from '@ids/position';
import { CloseIconControl } from '@ids/icon-control';
import { CircleCheckIcon } from '@ids/internal-icons';
import LinkActionButton from '@ids-beta/link-action-button';

// TODO Add design data
const backgroundElevationColor = 'rgba(0,0,0,.20)';
const backgroundPointerSpacing = '16px';
const badgeColorSuccess = get('badge.color.success');
const backgroundColor = get('background.color');

const topPositionLeftAlignment = css`
  margin-bottom: 16px;
  &:after,
  &:before {
    left: 26px;
  }
  &:after {
    top: 100%;
    border-top-color: ${backgroundColor};
    border-width: 8px;
    margin-left: -8px;
  }
  &:before {
    border-bottom-color: ${badgeColorSuccess};
    border-right-color: ${badgeColorSuccess};
    border-width: 6px;
    margin-left: -6px;
    top: calc(100% - 5px);
    transform: rotate(45deg);
    box-shadow: 1px 1px 1px 0 ${backgroundElevationColor};
  }
`;

const topPositionRightAlignment = css`
  margin-bottom: 16px;
  &:after,
  &:before {
    right: 26px;
  }
  &:after {
    top: 100%;
    border-top-color: ${backgroundColor};
    border-width: 8px;
    margin-right: -8px;
  }
  &:before {
    border-bottom-color: ${badgeColorSuccess};
    border-right-color: ${badgeColorSuccess};
    border-width: 6px;
    margin-right: -6px;
    top: calc(100% - 5px);
    transform: rotate(45deg);
  }
`;

const bottomPositionLeftAlignment = css`
  margin-top: ${backgroundPointerSpacing};
  &:after,
  &:before {
    bottom: 100%;
    left: 26px;
  }
  &:after {
    border-bottom-color: ${backgroundColor};
    border-width: 8px;
    margin-left: -8px;
  }
  &:before {
    border-bottom-color: ${badgeColorSuccess};
    border-width: 10px;
    margin-left: -10px;
  }
`;

const bottomPositionRightAlignment = css`
  margin-top: ${backgroundPointerSpacing};
  &:after,
  &:before {
    bottom: 100%;
    left: calc(100% - 26px);
  }
  &:after {
    border-bottom-color: ${backgroundColor};
    border-width: 8px;
    margin-left: -8px;
  }
  &:before {
    border-bottom-color: ${badgeColorSuccess};
    border-width: 10px;
    margin-left: -10px;
  }
`;

const leftPositionTopAlignment = css`
  margin-right: ${backgroundPointerSpacing};
  &::after,
  &::before {
    top: 26px;
  }
  &::after {
    left: 100%;
    border-left-color: ${backgroundColor};
    border-width: 8px;
    margin-top: -8px;
  }
  &::before {
    border-right-color: ${badgeColorSuccess};
    border-bottom-color: ${badgeColorSuccess};
    border-width: 6px;
    margin-top: -6px;
    left: calc(100% - 5px);
    transform: rotate(-45deg);
    box-shadow: 0 4px 3px -3px ${backgroundElevationColor};
  }
`;

const leftPositionBottomAlignment = css`
  margin-right: ${backgroundPointerSpacing};
  &:after,
  &:before {
    top: calc(100% - 26px);
  }

  &::after {
    left: 100%;
    border-left-color: ${backgroundColor};
    border-width: 8px;
    margin-top: -8px;
  }
  &::before {
    border-right-color: ${badgeColorSuccess};
    border-bottom-color: ${badgeColorSuccess};
    border-width: 6px;
    margin-top: -6px;
    left: calc(100% - 5px);
    transform: rotate(-45deg);
    box-shadow: 0 4px 3px -3px ${backgroundElevationColor};
  }
`;

const rightPositionTopAlignment = css`
  margin-left: ${backgroundPointerSpacing};
  &:after,
  &:before {
    top: 26px;
  }

  &:after {
    right: 100%;
    border-right-color: ${backgroundColor};
    border-width: 8px;
    margin-top: -8px;
  }
  &:before {
    border-bottom-color: ${badgeColorSuccess};
    border-right-color: ${badgeColorSuccess};
    border-width: 6px;
    margin-top: -6px;
    right: calc(100% - 5px);
    transform: rotate(135deg);
    box-shadow: 4px 0 3px -3px ${backgroundElevationColor};
  }
`;

const rightPositionBottomAlignment = css`
  margin-left: ${backgroundPointerSpacing};
  &:after,
  &:before {
    top: calc(100% - 26px);
  }

  &:after {
    right: 100%;
    border-right-color: ${backgroundColor};
    border-width: 8px;
    margin-top: -8px;
  }
  &:before {
    border-bottom-color: ${badgeColorSuccess};
    border-right-color: ${badgeColorSuccess};
    border-width: 6px;
    margin-top: -6px;
    right: calc(100% - 5px);
    transform: rotate(135deg);
    box-shadow: 4px 0 3px -3px ${backgroundElevationColor};
  }
`;

const pointerPlacementMap = {
  [placements.TOP_LEFT]: topPositionLeftAlignment,
  [placements.TOP_RIGHT]: topPositionRightAlignment,
  [placements.BOTTOM_LEFT]: bottomPositionLeftAlignment,
  [placements.BOTTOM_RIGHT]: bottomPositionRightAlignment,
  [placements.LEFT_TOP]: leftPositionTopAlignment,
  [placements.LEFT_BOTTOM]: leftPositionBottomAlignment,
  [placements.RIGHT_TOP]: rightPositionTopAlignment,
  [placements.RIGHT_BOTTOM]: rightPositionBottomAlignment
};

export const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  position: relative;
  height: auto;
  padding: ${get('background.spacing')};
  ${({ dismissible }) => (dismissible ? `padding-right: 36px !important;` : ``)}
  border-radius: 4px;
  min-width: 120px;
  min-height: 48px;
  max-width: 276px;
  border: ${get('border.stroke')} solid ${get('border.color')} !important;
  background: ${backgroundColor} !important;
  outline: none;
  font-family: Avenir Next forINTUIT, Helvetica, Arial, sans-serif !important;
  font-size: ${get('body.fontSize')} !important;
  font-style: ${get('body.fontStyle')} !important;
  font-weight: ${get('body.fontWeight')} !important;
  line-height: ${get('body.lineHeight')} !important;
  color: ${get('body.color')} !important;
  box-shadow: 0 1px 4px 0 ${backgroundElevationColor};

  &::after,
  &::before {
    border: solid transparent;
    content: ' ';
    height: 0;
    width: 0;
    position: absolute;
    pointer-events: none;
  }

  ${({ placement }) => pointerPlacementMap[placement] || ''}
`;

// TODO: DD ${get('badge.spacingRight')};
export const StyledSuccessIcon = styled(CircleCheckIcon)`
  fill: ${badgeColorSuccess};
  flex-shrink: 0;
  margin-right: 8px;
  height: ${get('badge.height')} !important;
  width: ${get('badge.width')} !important;
`;

// in IE flex-direction not doing right when mixing row and column
export const Content = styled.div`
  display: flex;
  flex-direction: column;
  @media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
    display: block;
  }
  * {
    margin: 0;
  }
`;

// TODO: no DD iconControl.spacingRight
export const StyledCloseIconControl = styled(CloseIconControl)`
  position: absolute;
  top: ${get('iconControl.spacingTop')};
  right: 8px;
`;

// in IE flex-direction not doing right when mixing row and column
export const StyledLinkActionButton = styled(LinkActionButton)`
  margin-top: ${get('linkAction.spacing')};
  align-self: flex-end;
  @media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
    float: right;
  }
`;
